module.exports = __webpack_public_path__ + "f226df98.svg";